function initRefreshStatusAiJob() {

    const container = $('.refresh-ai-job')
    const jobID = container.data('ai-job-id')
    if (container.length > 0) {
        $.getJSON(`/admin/journal_entries/refresh_status?job_id=${jobID}`, function(data) {
            container.html(data.message)
            if (data.pct < 100 && data.pct > 0) {
                setTimeout(initRefreshStatusAiJob, 1000);
            } else if (data.pct === 0) {
                container.closest('.container-alert').find('[role="status"]').remove()
                container.closest('.container-alert').addClass('bg-red-50 text-red-800 dark:bg-red-800 dark:text-red-300')
            } else if (data.pct === 100) {
                const params = new URLSearchParams(window.location.search);
                window.location.href = window.location.href.replace( /[\?#].*|$/, `?with_autocomplete=${jobID}&udp_id=${params.get("udp_id")}` );
            }
        });
    }
}

export { initRefreshStatusAiJob }